document.querySelectorAll(".question").forEach((question) => {
        question.addEventListener("click", () => {
          const item = question.closest(".item");
          item.classList.toggle("active");
        });
      });